import { useIntl } from '@doxyme/locale';
import { BodyS } from '@doxyme/ui-foundation/typography';
import { useTheme } from '@doxyme/ui-foundation/theme';
import { Icon } from '@doxyme/icons';
import { type VirtualBackground } from '../constants';
import { useVirtualBackgroundContainerStyles } from './virtualBackgroundContainer.styles';

import type { JSX } from 'react';

export type VirtualBackgroundItemProps = {
  background: VirtualBackground;
  onSelect: (background: VirtualBackground) => Promise<void>;
  selected: boolean;
};

export const VirtualBackgroundContainer = ({
  background,
  onSelect,
  selected,
}: VirtualBackgroundItemProps): JSX.Element => {
  const theme = useTheme();
  const styles = useVirtualBackgroundContainerStyles(theme);
  const { formatMessage } = useIntl();

  const iconsDefaultBg = (name: string): JSX.Element => {
    switch (name) {
      case 'virtualBackground.options.slightBlur': {
        return (
          <Icon.Drop
            type='filled'
            aria-hidden='true'
            size={24}
            color={theme.icon.primary}
          />
        );
      }
      case 'virtualBackground.options.blur': {
        return (
          <Icon.Drop2
            type='filled'
            aria-hidden='true'
            size={24}
            color={theme.icon.primary}
          />
        );
      }
      default: {
        return (
          <Icon.Cross
            type='filled'
            aria-hidden='true'
            size={24}
            color={theme.icon.primary}
          />
        );
      }
    }
  };

  return (
    <button
      type='button'
      key={background.index}
      aria-pressed={selected}
      aria-label={formatMessage({
        id: background.metadata.title,
      })}
      css={{
        ...styles.container,
        ...(background.default === true && styles.default),
        backgroundImage:
          Boolean(background.metadata.thumbnail) && !Boolean(background.default)
            ? `url(/v2${background.metadata.thumbnail as string})`
            : 'none',
      }}
      onClick={() => void onSelect(background)}
    >
      {Boolean(background.default) && iconsDefaultBg(background.metadata.title)}
      {Boolean(background.metadata.label) && (
        <BodyS
          tag='span'
          color={theme.text.generic.primary}
          fontWeight='medium'
        >
          {formatMessage({
            id: background.metadata.label,
          })}
        </BodyS>
      )}
    </button>
  );
};
